import { apiFuns } from "sw-hic";
let { get, put, del, post, genStandard, exceptedReqs } = apiFuns;

console.log(exceptedReqs);
const api = {
  /*********** 住院记录 ***********/
  LisRecord: {
    ...genStandard("lisRecord", "/api/proxy", false),
    queryApply: (para) => get(`/api/proxy/lisRecord/apply`, para),
  },
};

export default api;